import { api } from '../config'

export const removeCouponService = async (couponId: string) => {
  return await api.delete(`api/coupons/${couponId}`)
}
